import { useLocation } from 'react-router-dom';
import { AdminPageHeader } from '@ui';

type SchedulerSettingsPageHeaderProps = {
  backLinkPath: string;
};

export const SchedulerSettingsPageHeader = ({ backLinkPath }: SchedulerSettingsPageHeaderProps) => {
  const { state } = useLocation();
  const path = `${backLinkPath}?${new URLSearchParams(state).toString()}`;

  return <AdminPageHeader title="Settings" backToListLink={path} backLinkText="Back to Schedule" />;
};
